import React from 'react';
import styled from '@emotion/styled';
import Img01 from 'ui/images/top_for_agent/topService_img01@2x.png';
import Img02 from 'ui/images/top_for_agent/topService_img02@2x.png';
import Img03 from 'ui/images/top_for_agent/topService_img03@2x.png';
import Img04 from 'ui/images/top_for_agent/topService_img04@2x.png';
import Img05 from 'ui/images/top_for_agent/topService_img05@2x.png';
import { AgentSignUpRequest } from 'ui/components/company/screens/modals/AgentSignUpRequest/AgentSignUpRequest';
import { useModal } from 'ui/components/screens/modals/useModal';
import { mqMin } from 'utils/responsive';

const Container = styled.section`
    background-color: var(--color-lightblue);
    padding: 61px 0 75px 0;

    img {
        display: block;
        max-width: 100%;
    }

    ${mqMin('NARROW')} {
        padding: 79px 0 87px 0;
    }
`;

const H2 = styled.h2`
    text-align: center;
    letter-spacing: 0.1em;
    font-size: 1.625rem; /*26px*/
    margin-bottom: 37px;

    ${mqMin('NARROW')} {
        font-size: 1.75rem; /*28px*/
        margin-bottom: 42px;
    }
`;

const DescriptionContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: stretch;
    width: 93.02325581395349%;
    max-width: 400px;
    margin: 0 auto 57px auto;

    ${mqMin('SP')} {
        max-width: initial;
    }

    ${mqMin('NARROW')} {
        margin: 0 auto 77px auto;
    }
`;

const DescriptionItem = styled.div`
    width: 49%;
    background-color: #fff;
    border-radius: 8px;
    padding: 24px 0;
    margin: 0 1% 12px 0;

    &:nth-child(even) {
        margin: 0 0 12px 1%;
    }

    ${mqMin('SP')} {
        width: 215px;
        padding: 24px 0;
        margin: 0 6px 12px 6px;

        &:nth-child(even) {
            margin: 0 6px 12px 6px;
        }
    }

    ${mqMin('NARROW')} {
        width: 215px;
        padding: 24px 0;
        margin: 0 6px 12px 6px;

        &:nth-child(even) {
            margin: 0 6px 12px 6px;
        }
    }
`;

const ImgItem = styled.img`
    width: auto;
    height: 115px;
    margin: 0 auto 20px auto;
`;

const H3 = styled.h3`
    font-size: 0.875rem; /*14px*/
    letter-spacing: 0.1em;
    text-align: center;

    &::after {
        content: '';
        display: block;
        width: 28px;
        height: 2px;
        background-color: var(--color-navy);
        margin: 12px auto;
    }
`;

const Text = styled.p`
    text-align: center;
    font-size: min(4vw, 18px);
    line-height: 1.6em;
    letter-spacing: 0.1em;
`;

const NoteP = styled.p`
position: relative;
    text-align: center;
    font-size: 1.125rem; /*18px*/
    letter-spacing: 0.1em;
    margin-bottom: 10px;

    strong {
    position: relative;

    &::before {
     position: absolute;
    top: -10px;
    left: 50%;
    content: "・";
    transform: translateX(-50%);
    font-size: 16px;
    }
    `;

const Link = styled.a`
    width: 320px;
    letter-spacing: 0.05em;
    margin: 0 auto 0 auto;
    padding: 20px 0;
    display: block;
    background-color: var(--color-orange);
    border-radius: 8px;
    border: solid 2px #fff;
    color: #fff;
    text-align: center;
    text-decoration: none;
    transition: all 0.3s;

    &:visited {
        color: #fff;
    }

    &:hover {
        background-color: #fff;
        border: solid 2px var(--color-orange);
        color: var(--color-orange);
    }

    ${mqMin('NARROW')} {
        width: 287px;
    }
`;

export const AboutService: React.FC = () => {
    const modal = useModal();
    const { createModal, openModal } = modal;

    return (
        <Container>
            {createModal(<AgentSignUpRequest />)}
            <H2 className="fadein fadein_y">MAnyサービスの流れ</H2>
            <DescriptionContainer className="fadeinLi">
                <DescriptionItem>
                    <ImgItem src={Img01} alt="STEP1のイメージ" />
                    <H3>STEP01</H3>
                    <Text>アカウント作成</Text>
                </DescriptionItem>
                <DescriptionItem>
                    <ImgItem src={Img02} alt="STEP2のイメージ" />
                    <H3>STEP02</H3>
                    <Text>M&A検討企業の相談投稿を検索・確認</Text>
                </DescriptionItem>
                <DescriptionItem>
                    <ImgItem src={Img03} alt="STEP3のイメージ" />
                    <H3>STEP03</H3>
                    <Text>
                        企業に
                        <br />
                        オファーを送信
                    </Text>
                </DescriptionItem>
                <DescriptionItem>
                    <ImgItem src={Img04} alt="STEP4のイメージ" />
                    <H3>STEP04</H3>
                    <Text>
                        相手が「了承」すると
                        <br />
                        マッチング成立
                    </Text>
                </DescriptionItem>
                <DescriptionItem>
                    <ImgItem src={Img05} alt="STEP5のイメージ" />
                    <H3>STEP05</H3>
                    <Text>
                        M&A検討企業の詳細情報が開示、交渉開始
                        <br />
                    </Text>
                </DescriptionItem>
            </DescriptionContainer>
            <div className="fadein fadein_y">
                <NoteP>
                    マッチング成立までは<strong>基</strong>
                    <strong>本</strong>
                    <strong>無</strong>
                    <strong>料</strong>
                </NoteP>
                <Link href="#" onClick={openModal}>
                    無料登録して企業を探す
                </Link>
            </div>
        </Container>
    );
};
